// extracted by mini-css-extract-plugin
export default {"serviceSetupContainer":"ServiceSetup_serviceSetupContainer__k-aXc"};